// extracted by mini-css-extract-plugin
export default {"cta":"fF-z","disabled":"gF-z"};